module.exports = __webpack_public_path__ + "img/common-file-remove.2a359238.svg";